import React from 'react';
import styled from 'styled-components';
import { CheckCircleFilledIcon } from 'tdesign-icons-react';
import { Link, Tooltip } from 'tdesign-react';
import Descriptions from '@/components/Descriptions';
import DescriptionItem from '@/components/DescriptionItem';
import { ReactComponent as IconSvg } from './icon.svg';

export default function ClusterItem({
  clusterName,
  brokerUrl,
  clusterDisplayName,
  primary,
  inUse,
  handleSwitch,
}) {
  const primaryColor = primary ? 'rgb(16, 184, 128)' : '#3361ff';
  const secondaryColor = primary ? 'rgb(207, 241, 230)' : '#D6DFFF';
  return (
    <Root primaryColor={primaryColor}>
      <Panel primaryColor={primaryColor} secondaryColor={secondaryColor}>
        <Header>
          <TitleBlock primaryColor={primaryColor}>
            {primary ? '主集群' : '备集群'}

            <IconSvg className='t-icon title-icon' />
          </TitleBlock>
        </Header>
        {inUse ? (
          <Tooltip content='当前集群对外提供服务'>
            <CheckCircleFilledIcon className='right-pos status-icon' />
          </Tooltip>
        ) : (
          <Link className='right-pos' theme='primary' hover='color' onClick={handleSwitch}>
            切换
          </Link>
        )}
        <Title>{clusterName}</Title>
        <Descriptions>
          <DescriptionItem span={3} label='集群备注' value={clusterDisplayName} />
          <DescriptionItem span={3} label='服务地址' value={brokerUrl} />
        </Descriptions>
      </Panel>
    </Root>
  );
}

const Root = styled.div`
  width: 100%;
  padding: 1px 1px 1px 4px;
  box-sizing: border-box;
  background: ${(props) => props.primaryColor};
  border-radius: 4px;
`;

const Panel = styled.div`
  border-radius: 4px;
  background: ${(props) => props.secondaryColor};
  padding: 8px 8px 8px 12px;
  position: relative;
  .right-pos {
    position: absolute;
    right: 8px;
    top: 8px;
  }
  .status-icon {
    width: auto;
    height: 20px;

    color: ${(props) => props.primaryColor};
    fill: #fff;
  }
  .descriptions {
    margin-bottom: 5px;
    .t-col {
      padding: 1px !important;
    }
    .description-label {
      font-size: 13px;
      line-height: 17px;
    }
    .description-value {
      font-size: 13px;
      line-height: 17px;
    }
  }
`;

const TitleBlock = styled.div`
  border-radius: 3px;
  height: 17px;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 6px 0 14px;
  box-sizing: border-box;
  background-color: ${(props) => props.primaryColor};
  color: white;
  position: relative;
  .title-icon {
    position: absolute;
    left: -5px;
    top: 0;
    bottom: 0px;
    width: auto;
    height: 17px;
    color: ${(props) => props.primaryColor};
    fill: #fff;
    box-sizing: border-box;
    border-radius: 100%;
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);
  }
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
`;

const Title = styled.div`
  color: rgb(13, 17, 26);
  font-size: 14px;
  font-weight: 500;
  line-height: 28px;
  letter-spacing: 0px;
  text-align: left;
  margin: 2px 0 4px;
`;
